import { Redirect, Route, Switch } from 'react-router-dom'

interface HomeRoute {
  component: (params: any) => JSX.Element
  path: string
}

interface HomeRoutesProps {
  defaultRoute: string
  homeRoutes: HomeRoute[]
}

function HomeRoutes(props: HomeRoutesProps) {
  const { defaultRoute, homeRoutes } = props

  return (
    <Switch>
      {homeRoutes.map(({ component, path }) => (
        <Route key={path} path={path} component={component} />
      ))}
      <Route path="*">
        <Redirect to={defaultRoute} />
      </Route>
    </Switch>
  )
}

export default HomeRoutes
